import React from 'react';
import PropTypes from 'prop-types';
import ArrowDropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import moment from 'moment';
import R from 'ramda';

import {
  Chip,
  TableRow,
  TableRowColumn,
  Avatar,
  FontIcon,
  MenuItem,
} from 'material-ui';
import { JiraFlatButton, SmallRaisedButton } from '../../tc-ui/small-buttons';
import FlatDropDownMenu from '../../tc-ui/flatDropDownMenu';
import { getShownState, getStatusColor, stateValMap } from '../../contracting/contractingUtils';

const ContractRowDumb = ({
  contract,
  actions,
}) => {
  const {
    _id,
    locationId,
    locationName,
    respondedContracts,
    from,
    versions = [],
    isViewed,
    startDate,
    endDate,
    updatedAt,
    supplierInfo,
  } = contract;
  const tcContractsInRequest = Boolean(
    !locationId && respondedContracts && respondedContracts.length,
  );
  const shownState = getShownState({ companyType: 'Contractor', ...contract });
  const hasVersion = !R.either(R.isNil, R.isEmpty)(versions);
  const iconToDisplay = (() => {
    if (locationName) return 'tc-icon-location_on';
    return '';
  })();
  const unread = Boolean(locationId && !isViewed);
  const stateChange = newStatus => actions.updateContractStatus(
    { contractIds: [_id], state: newStatus },
  );
  const outdated = endDate < new Date().toISOString();
  return (
    <TableRow
      selectable={false}
      style={{ height: '56px', overflow: 'visible' }}
    >
      <TableRowColumn colSpan="7" style={{ overflow: 'visible' }}>
        <div className="flex-center" style={{ color: outdated ? 'rgba(0, 0, 0, 0.34)' : 'rgba(0, 0, 0, 0.74)' }}>
          {
            R.call(R.cond([
              [() => from && from.avatar, R.always(<Avatar src={from.avatar} style={{ marginTop: '4px' }}/>)],
              [R.T, R.always(<Avatar>{R.head(from.name || '')}</Avatar>)],
            ]))
          }
          <div
            style={{ height: '48px', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '24px' }}
          >
            <div style={{ fontWeight: unread ? 'bold' : '', lineHeight: '16px' }}>
              <span style={{ fontSize: '14px' }}>{from.name}</span>
              <small>
                &nbsp;
                <i>{hasVersion ? `(v.${versions.length + 1})` : ''}</i>
              </small>
            </div>
            <div style={{ fontWeight: unread ? 'bold' : '', display: 'flex', alignItems: 'center', lineHeight: '14px' }}>
              {iconToDisplay ? <FontIcon className="tc-icon-location_on" style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginRight: '8px' }} /> : <span/>}
              {locationName}
              {
                R.path(['marketInfo'], supplierInfo) ? (
                  <small>
                    &nbsp;
                    {`(${R.path(['marketInfo'], supplierInfo)})`}
                  </small>
                ) : <span />
              }
            </div>
          </div>
        </div>
      </TableRowColumn>
      <TableRowColumn
        colSpan="2"
        style={{ padding: 0, textAlign: 'center' }}
      >
        <FlatDropDownMenu
          button={(
            <JiraFlatButton
              icon={(
                <ArrowDropDownIcon
                  style={{
                    fill: 'rgba(0, 0, 0, 0.84)',
                    width: '24px',
                    margin: 0,
                    position: 'relative',
                    top: '-2px',
                  }}
                />
               )}
              labelStyle={{
                padding: '0 4px',
                top: '-2px',
                color: getStatusColor(shownState),
              }}
              style={{ border: '1px solid #dce1e6' }}
              labelPosition="before"
              label={shownState}
            />
          )}
        >
          <MenuItem
            primaryText="Mark as Received"
            style={{ color: getStatusColor('received') }}
            disabled={shownState === 'received'}
            onTouchTap={() => stateChange('received')}
          />
          <MenuItem
            primaryText="Mark as Accepted"
            style={{ color: getStatusColor('accepted') }}
            disabled={shownState === 'accepted'}
            onTouchTap={() => stateChange('accepted')}
          />
          <MenuItem
            primaryText="Mark as Loading"
            style={{ color: getStatusColor('loading') }}
            disabled={shownState === 'loading'}
            onTouchTap={() => stateChange('loading')}
          />
          <MenuItem
            primaryText="Mark as Loaded"
            style={{ color: getStatusColor('loaded') }}
            disabled={shownState === 'loaded'}
            onTouchTap={() => stateChange('loaded')}
          />
          <MenuItem
            primaryText="Mark as Rejected"
            style={{ color: getStatusColor('rejected') }}
            disabled={shownState === 'rejected'}
            onTouchTap={() => stateChange('rejected')}
          />
        </FlatDropDownMenu>
      </TableRowColumn>
      <TableRowColumn
        colSpan="1"
        style={{
          padding: 0, textAlign: 'center', whiteSpace: 'pre-wrap', fontSize: '10px'
        }}
      >
        {`${moment.utc(startDate).format('D MMM YY')} -\n${moment.utc(endDate).format('D MMM YY')}  `}
      </TableRowColumn>
      <TableRowColumn colSpan="1" style={{ padding: 0, fontSize: '11px', textAlign: 'center' }}>
        {moment(updatedAt).calendar(null, {
          sameDay: 'h:mm a',
          lastDay: 'D MMM YY',
          lastWeek: 'D MMM YY',
          sameElse: 'D MMM YY',
        })}
      </TableRowColumn>
      <TableRowColumn
        colSpan="1"
        style={{ padding: 0, textAlign: 'center', overflow: 'visible' }}
      >
        <SmallRaisedButton
          labelStyle={{ padding: '4px', top: 0 }}
          label="Download"
          secondary
          onTouchTap={() => actions.downloadRates(_id)}
        />
      </TableRowColumn>
    </TableRow>
  );
};

ContractRowDumb.propTypes = {
  contract: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default ContractRowDumb;



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/basic-contract-list/contract-row.jsx